import React, { useState, useEffect } from "react"
import _ from "lodash"

import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { DropdownInput, NumberInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

import { ProRataRecovery_s } from "components/recoveries/named-recoveries/named-recoveries-styles"

const TenantMgmtFee = (props: {rowData: [], namedItems: any, field: string, persist: Function}) => {

  const emptyRecord = {
    percent: null,
    revenueType: 'Rent + Recovery',
    reportTagNamedItemId: null
  }

  const [data, setData] = useState<object|null>(props.rowData['recoverydetail']);

  useEffect(() => {
    if (!props['rowData'] || props['rowData']['recoverydetail']['state'] !== 'tenantMgmtFee') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val:any, field:string):void {
    let nextData = _.cloneDeep(data)
    nextData[field] = val
    setData(nextData);
    props.persist({...nextData, state: 'tenantMgmtFee'}, 'recoverydetail', props.rowData)
  }

  const reportTagOptions = props.namedItems.reportTags?.map(tag => { 
    if (tag.code) return {label: tag.code, value: tag.reporttagid} 
  })

  const attrs = (field) => field_attrs('recovery', 'recoverydetail')(field)(props.rowData, props)

  return (
    <ProRataRecovery_s>
      <SingleRowCarouselState_s>
        <div className="short-input">
          <label>Percent</label>
          <NumberInput 
            className="automated" 
            data={data} 
            attrs={attrs} 
            field="percent" 
            readPrecision={4} 
            writePrecision={4} 
            min={0} 
            max={100} 
            persist={updateData} 
          />
        </div>   
        <div>
          <label>Revenue Type</label>
          <DropdownInput 
            className="automated" 
            data={data} 
            attrs={attrs} 
            field={'revenueType'} 
            options={['Rent', 'Rent + Recovery', 'All Revenues']} 
            persist={updateData} 
          />
        </div>      
        <div>
          <label>Report Tag</label>
          <DropdownInput 
            className="automated reporttag" 
            data={data} 
            attrs={attrs} 
            field={'reportTagNamedItemId'} 
            options={reportTagOptions} 
            persist={updateData} 
            onClear={() => updateData(null, 'reportTagNamedItemId')}
          />
        </div>   
      </SingleRowCarouselState_s>
    </ProRataRecovery_s>
  )
}

export default TenantMgmtFee
